/** «Контроль → Доставка»: ответ ручки `/api/control/delivery`. */
import { apiFetch, query } from "@/lib/api";
import type { Money } from "@/lib/pnl";

export type DeliveryKind = "to_client" | "from_client" | "office" | "other";
export type DealMatch = "note" | "crm" | "phone" | "";

export const KIND_LABEL: Record<DeliveryKind, string> = {
  to_client: "к клиенту",
  from_client: "от клиента",
  office: "между офисами",
  other: "без офиса",
};

export const MATCH_LABEL: Record<DealMatch, string> = {
  note: "по заметке",
  crm: "привязка CRM",
  phone: "по телефону",
  "": "",
};

export const MATCH_HINT: Record<DealMatch, string> = {
  note: "номер сделки в заметке заказа («заказ *1245568*»)",
  crm: "заказ привязан к сделке в CRM (трек-номер)",
  phone: "телефон клиента → сделка, чья дата выдачи/возврата ближе всего ко дню заказа (≤ 10 дней)",
  "": "",
};

export type DeliveryMonth = {
  month: string;
  orders: number;
  spent: Money;
  spent_with_deal: Money;
  spent_without_deal: Money;
  without_deal: number;
  charged: Money;
  diff: Money;
  linked: number;
  linked_amount: Money;
  bank_out: Money;
  bank_in: Money;
  bank_net: Money;
};

export type DeliveryDeal = {
  deal_crm_id: number;
  client_name: string;
  city: string;
  rent_start: string | null;
  rent_end: string | null;
  contracts: number;
  orders: number;
  to_client: number;
  from_client: number;
  spent: Money;
  charged: Money;
  diff: Money;
};

export type DeliveryOrder = {
  id: number;
  number: string;
  date: string;
  status: string;
  kind: DeliveryKind;
  amount: Money;
  spent: Money;
  address_from: string;
  address_to: string;
  phone: string;
  note: string;
  matter: string;
  deal_crm_id: number | null;
  deal_match: DealMatch;
  bank_operation_id: number | null;
  bank_date: string | null;
};

export type DeliveryReport = {
  period: { date_from: string; date_to: string };
  totals: Omit<DeliveryMonth, "month"> & { deals: number };
  months: DeliveryMonth[];
  deals: DeliveryDeal[];
  orders: DeliveryOrder[];
};

export function loadDelivery(filter: { date_from: string; date_to: string }): Promise<DeliveryReport> {
  return apiFetch<DeliveryReport>(`/api/control/delivery${query(filter)}`);
}

export type DeliverySyncReport = {
  started: string;
  finished: string | null;
  pages: number;
  total_pages: number;
  orders: { new?: number; updated?: number; unchanged?: number };
  deals: { note?: number; crm?: number; phone?: number; none?: number; deals?: number };
  bank: { charges?: number; linked?: number };
  error: string | null;
};

export type DeliverySyncState = { running: boolean; report: DeliverySyncReport | null };

export function loadDeliverySync(): Promise<DeliverySyncState> {
  return apiFetch("/api/control/delivery/sync");
}

export function startDeliverySync(): Promise<DeliverySyncState> {
  return apiFetch("/api/control/delivery/sync", { method: "POST" });
}

/** Карточка сделки в prokat: КЦ, салон, договор и оплаты одной лентой. */
export function dealUrl(id: number): string {
  return `https://prokat.uni-renter.ru/deals/${id}`;
}

export function orderUrl(number: string): string {
  return `https://dostavista.ru/cabinet/order-view/${number}`;
}
